import { lazy } from "react"
import { EnergyPassportPage } from "@/features/energy-passport/ui"
import EnergyPassportWrapper from "@/features/energy-passport/ui/energy-passport-wrapper.tsx"
import type { CustomRoute } from "@/shared/types"

// const EnergyPassportComponent = lazy(async () => await import("@/pages/dashboard/energy-passport"))
const CurrentEnergyAudit = lazy(async () => await import("@/pages/dashboard/company-energy-audit/current/ui"))
const EnergyAuditDetail = lazy(async () => await import("@/features/energy-audit/view-role/company/current/energy-audit-detail"))
const CreateEnergyAuditDetail = lazy(async () => await import("@/pages/dashboard/company-energy-audit/current/ui/energy-audit-detail/create"))
const ProtocolActionEnergyAuditDetail = lazy(
  async () => await import("@/pages/dashboard/company-energy-audit/current/ui/energy-audit-detail/protocol-actions")
)
const CommentPage = lazy(async () => await import("@/pages/dashboard/company-energy-audit/current/ui/Comment"))
const OTMPage = lazy(async () => await import("@/pages/dashboard/company-energy-audit/current/ui/Otm"))
const AuditProgramPage = lazy(async () => await import("@/features/audit-program/ui/index"))
const CompanyEnergyAuditCurrentProgramHistory = lazy(async () => await import("@/features/audit-program/ui/program-history-page.tsx"))
const AuditorProfilePage = lazy(async () => import("@/pages/dashboard/auditor-portfolio/auditor-profile"))

export const companyEnergyAuditCurrentRoutes: CustomRoute = {
  path: "current",
  children: [
    {
      index: true,
      handle: { label: "Текущие", i18Key: "energy-audit" },
      Component: CurrentEnergyAudit
    },
    {
      path: ":id/",
      handle: { label: "Подробнее", i18Key: "moreDetails", keepSearchParams: ["requestId"] },
      children: [
        {
          index: true,
          Component: EnergyAuditDetail
        },
        {
          path: "create",
          handle: { label: "Создать", i18Key: "create" },
          Component: CreateEnergyAuditDetail
        },
        {
          path: "comment",
          handle: { label: "Протокол действий", i18Key: "protocol-action", hideTabs: true },
          Component: CommentPage
        },
        {
          path: "otm",
          handle: { label: "Протокол действий", i18Key: "protocol-action", hideTabs: true },
          Component: OTMPage
        },
        {
          path: "view-portfolio",
          handle: { i18Key: "protocol-action", hideTabs: true },
          Component: AuditorProfilePage
        },
        {
          path: "energy-passport/:contractId/:year/",
          handle: { i18Key: "energy-passport", hideTabs: true },
          element: (
            <EnergyPassportWrapper>
              <EnergyPassportPage />
            </EnergyPassportWrapper>
          )
        },
        {
          path: "program/:programId",
          handle: { label: "Программа", i18Key: "view", hideTabs: true },
          Component: AuditProgramPage
        },
        {
          path: "program-history",
          handle: { label: "Program", i18Key: "makeNewProgram", hideTabs: true },
          Component: CompanyEnergyAuditCurrentProgramHistory
        },
        {
          path: "protocol-action",
          handle: { label: "Протокол действий", i18Key: "protocol-action", hideTabs: true },
          Component: ProtocolActionEnergyAuditDetail
        }
      ]
    }
  ]
}
